<template>
	<section class="page">
		<section class="loginForm">
			<h1 class="text-center">UNIK</h1>
			<el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="top">
				<el-form-item label="手机号" prop="phone" :error="err.phone">
					<el-input v-model="form.phone"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password" :error="err.password">
					<el-input type="password" v-model="form.password"></el-input>
				</el-form-item>
				<el-form-item class="loginSubmit">
					<el-button type="primary" @click="doLogin()">登录</el-button>
				</el-form-item>
			</el-form>
		</section>
		<vue-particles
			color="#dedede"
			:particleOpacity="1"
			shapeType="circle"
			:particleSize="5"
			linesColor="#e0e0e0"
			:linesWidth="1"
			:lineLinked="true"
			:lineOpacity="1"
			:linesDistance="150"
			:moveSpeed="4"
			:hoverEffect="true"
			hoverMode="grab"
			:clickEffect="true"
			clickMode="push"
			class="particles"
		></vue-particles>
	</section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Vue from "vue";
import VueParticles from "vue-particles";
Vue.use(VueParticles);

export default {
	name: "User-Login",
	data() {
		return {
			form: {
				phone: "",
				password: "",
			},
			err: {
				phone: "",
				password: "",
			},
			loading: false,
			rules: {
				phone: [
					{
						required: true,
						message: "请输入手机号",
						trigger: "blur",
					},
				],
				password: [
					{ required: true, message: "请输入密码", trigger: "blur" },
					{
						min: 6,
						max: 15,
						message: "密码长度在 6-12 位之间",
						trigger: "change",
					},
				],
			},
		};
	},

	computed: {},
	created() {},
	mounted() {},

	methods: {
		...mapMutations(["doLoginToken"]),
		resetFormValidation() {
			for (var k in this.err) {
				this.err[k] = "";
			}
		},
		doLogin() {
			this.$refs["form"].validate(valid => {
				if (valid) {
					this.resetFormValidation();
					this.loading = true;
					this.$axios
						.post("/admin/login", this.form)
						.then(json => {
							this.$message({
								message: "登录成功",
								type: "success",
							});
							this.loading = false;

							this.$store.commit("doLoginToken", json.data);
							let path = "/";
							if (this.$route.query.redirect) {
								path = this.$route.query.redirect;
							}
							this.$router.replace({
								path: "/",
							});
						})
						.catch(json => {
							this.loading = false;
							this.err[json.data.field] = json.data.msg;
						});
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
	},
	components: {},
};
</script>
<style lang="scss" scoped>
.page {
	width: 100%;
	height: 100%;
	.particles {
		position: absolute;
		left: 0;
		top: 0;
		z-index: -1;
		width: 100%;
		height: 100%;
		background-position: center center;
		background-size: cover;
	}
}
.loginForm {
	margin-top: 20vh;
	z-index: 1;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	align-content: stretch;
	.el-form {
		width: 500px;
		.loginSubmit {
			display: flex;
			justify-content: center;
		}
	}
}
</style>